import { QUANTO_CUSTA } from '../conteudo';

// Quanto custa — texto que já existia na página, sem mudar valores.
export default function QuantoCusta() {
  return (
    <section className="app-entra mt-10" style={{ animationDelay: '180ms' }}>
      <h2 className="text-[19px] font-extrabold text-foreground-950 md:text-[24px]">
        {QUANTO_CUSTA.titulo}
      </h2>
      <div className="mt-4 rounded-[18px] border border-background-200 bg-background-50 p-4 shadow-pcard">
        <p className="text-[15px] leading-relaxed text-foreground-700">{QUANTO_CUSTA.texto}</p>
      </div>
    </section>
  );
}